import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { CONTACT_EMAIL } from '../components/LegalPolicyContent';
import '../styles/PolicyPage.css';

export default function DataDeletionPage({ user }) {
  return (
    <div className="page-shell">
      <Header user={user} showMenu={false} />
      <main className="page-main">
        <section className="policy-page">
          <h1>データ削除ガイド / Data Deletion Guide</h1>
          <p className="policy-lead">
            Chord Analyzerに保存されたデータ（スコア情報）の削除方法を説明します。 / This page explains how to delete data (score information) saved in Chord Analyzer.
          </p>

          <h2>1. アプリ内で削除 / Delete from within the app</h2>
          <p>
            ログイン後、スコア一覧から対象スコアを選択して削除してください。削除したデータは復元できません。
            <br />
            After logging in, select the target score from the score list and delete it. Deleted data cannot be restored.
          </p>

          <h2>2. アカウント連携の解除 / Revoke account linking</h2>
          <p>
            Googleアカウントの接続済みアプリ一覧から、Chord Analyzerのアクセス権を解除できます。
            <br />
            You can revoke Chord Analyzer access from your Google account's connected apps list.
          </p>

          <h2>3. サポートへの削除依頼 / Request deletion from support</h2>
          <p>
            データ削除の依頼は <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> までご連絡ください。
            <br />
            For data deletion requests, contact <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}
